import { Role } from "features/Permission/types";
import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";

interface UserAccessContextProps {
  role: Role;
  setRole: (role: Role) => void;
}

const UserAccessContext = createContext<UserAccessContextProps | null>(null);

export const UserAccessProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { userDetails } = useAuth();
  const [role, setRole] = useState<Role>(userDetails?.role as Role);

  useEffect(() => {
    if (userDetails) {
      setRole(userDetails.role as Role);
    }
  }, [userDetails?.role]);

  return (
    <UserAccessContext.Provider value={{ role, setRole }}>
      {children}
    </UserAccessContext.Provider>
  );
};

export const useUserAccess = () => {
  const context = useContext(UserAccessContext);
  if (!context) {
    throw new Error("useUserAccess must be used within a UserAccessProvider");
  }
  return context;
};
